export default [
  {
    path: "/cryptoConfigurations",
    component: () => import(/* webpackChunkName: "layout" */ "./layout"),

    children: [
      {
        path: "countries",
        name: "crypto.countries",
        component: () =>
          import(/* webpackChunkName: "crypto.countries" */ "./transactionCountries"),
      },
      {
        path: "paymentTypes",
        name: "crypto.paymentTypes",
        component: () => import(/* webpackChunkName: "crypto.paymentTypes" */ "./paymentTypes"),
      },
      {
        path: "paymentProviders",
        name: "crypto.paymentProviders",
        component: () =>
          import(/* webpackChunkName: "crypto.paymentProviders" */ "./paymentProviders"),
      },
      {
        path: "cashInMethods",
        name: "crypto.cashInMethods",
        component: () => import(/* webpackChunkName: "crypto.cashInMethods" */ "./cashInMethods"),
      },
      {
        path: "cashoutMethods",
        name: "crypto.cashoutMethods",
        component: () => import(/* webpackChunkName: "crypto.cashoutMethods" */ "./cashoutMethods"),
      },
    ],
  },
];
